<template>
  <button
    type="button"
    class="-m-2.5 p-2.5 relative text-neutral-400 hover:text-neutral-500 dark:hover:text-neutral-300"
    @click="$refs.sidebar.open">
    <span class="sr-only">View notifications</span>
    <i class="fa-sharp fa-regular fa-bell fa-fw" aria-hidden="true"></i>
    <span
      v-if="unreadCount > 0"
      class="absolute min-w-4 -bottom-0.5 -right-0.5 bg-red-600 dark:bg-red-700 px-1 rounded-full text-white text-xs">
      {{ $filters.number(unreadCount) }}
    </span>
  </button>

  <NtNotificationSidebar ref="sidebar" />
</template>

<script>
import { mapState } from 'pinia'
import NtNotificationSidebar from './NtNotificationSidebar.vue'
import { useNotificationStore } from '@/stores/notifications'

export default {
  components: { NtNotificationSidebar },
  computed: {
    ...mapState(useNotificationStore, ['notifications']),
    unreadCount() {
      return this.notifications.filter((n) => !n.read_at).length
    }
  }
}
</script>
